<template>
  <div class="post-form-media">
    <div class="wrapper media-wrapper">
      <label>Медіафайли</label>

      <div class="field">
        <post-form-media-items
          v-model="mediaList"
          lockAxis="y"
          useDragHandle
        >
          <post-form-media-item
            v-for="(item, index) in mediaList"
            :index="index"
            :key="index"
            :item.sync="item"
            @remove="removeItem(index)"
          ></post-form-media-item>
        </post-form-media-items>
      </div>

      <div class="uploader">
        <input
          @change="onFilesAdded"
          type="file"
          multiple></input>
        <v-icon>add</v-icon>Додати медіафайли
      </div>
    </div>
  </div>
</template>

<script>

import PostFormMediaItems from '@/components/PostFormMediaItems';
import PostFormMediaItem from '@/components/PostFormMediaItem';

const VIDEO = 'video';
const AUDIO = 'audio';
const IMAGE = 'image';
const ALLOWED_MEDIA_TYPES = [VIDEO, AUDIO, IMAGE];

export default {
  name: 'PostFormMedia',
  components: {
    PostFormMediaItems,
    PostFormMediaItem,
  },
  props: {
    media: {
      type: Array,
      required: true,
    },
  },
  computed: {
    mediaList: {
      get() {
        return this.media;
      },
      set(value) {
        this.$emit('update:media', value);
      },
    },
  },
  methods: {
    onFilesAdded($event) {
      const files = $event.target.files;
      if (files && files.length) {
        this.mediaList = this.mediaList
          .concat(this.convertFilesToMedia(files, this.mediaList.length));
      }
    },
    convertFilesToMedia(files, index) {
      const media = [];

      [...files].forEach((file) => {
        const type = this.getType(file.type);

        if (ALLOWED_MEDIA_TYPES.includes(type)) {
          media.push({
            type,
            order: index + media.length,
            [type]: {
              input: file,
            },
          });
        }
      });

      return media;
    },
    getType(mimeType) {
      return mimeType.split('/')[0];
    },
    removeItem(index) {
      this.mediaList.splice(index, 1);
    },
  },
};

</script>

<style scoped>

.media-wrapper .field {
  border: solid 1px rgba(0, 0, 0, 0.1);
  min-height: 34px;
  background: #fff;
}

.media-wrapper input {
  border: none;
}

.uploader {
  position: relative;
  padding: 5px;
}

.uploader input {
  border: none;
  position: absolute;
  top: 0;
  bottom: 0;
  opacity: 0;
}

.uploader .icon {
  margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/PostFormMedia.vue